import type { ChallengeOutcome } from "@highmarch/app";
import { ticksToMs } from "@highmarch/app";
import { LevelSim } from "@highmarch/domain";
import { rowHtml } from "../components";
import { paintedIconHtml } from "../featureIcons";
import { fmtClear } from "./challengeWords";

/** The crest's painted scroll and the row's lead (CSS px), as Daily Road's. */
const CREST_PX = 56, LEAD_PX = 28;

/** The end screen's crest for a challenge code's run: the clear time on a win, the wave reached on a loss. */
export function challengeCrestHtml(sim: LevelSim, won: boolean): string {
  const value = won ? fmtClear(ticksToMs(sim.tick)) : `WAVE ${sim.stagesCleared}/${sim.stages}`;
  return `<div class="modecrest challenge${won ? " earned" : ""}"><span class="ic">${paintedIconHtml("challenge", CREST_PX)}</span><b class="disp">${value}</b><small>${won ? "clear time" : "reached"}</small></div>`;
}

/**
 * The end screen's challenge block (MP-28, docs/MODES.md §7): the code and its best (NEW BEST stamped), and that a
 * code pays nothing but glory: the best goes to the Hall of Records. A fact, never an offer.
 */
export function challengeEndHtml(o: ChallengeOutcome): string {
  const b = o.best, best = b === null ? "—" : b.won ? fmtClear(b.ms) : `wave ${b.stages}`;
  const stamp = o.note.counted && o.note.newBest && o.note.previous !== null ? `<b class="enstamp disp">NEW BEST!</b>` : "";
  const row = rowHtml({ lead: paintedIconHtml("challenge", LEAD_PX), title: "FOR GLORY", sub: `${o.code} · no rewards: your best hangs in the Hall of Records`, compact: true, className: "erow challenge" });
  return `<div class="evend modeend challengeend stack">
    <div class="chscore">${stamp}<small>This code's best</small><b class="disp">${best}</b></div>
    ${row}
  </div>`;
}
